import {
    useRef
} from 'react';

import { SimpleGrid, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

import { useInvoiceItems } from '../hooks/useInvoiceItems.ts';
import { useInvoiceItemsSelection } from '../hooks/useInvoiceItemsSelection.ts';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableColumn } from "mantine-datatable";
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";
import { InvoiceItem } from '../types';

export const RecordsTable = () => {

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useInvoiceItems('');

    const { selectedRecords, setSelectedRecords } = useInvoiceItemsSelection();



    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const columns: DataTableColumn<InvoiceItem>[] = [
        {
            accessor: 'id',
            title: 'Invoice Item',
            render: (record: InvoiceItem) => (
                <Link to={`/invoice-items/${record.id}`} style={{ textDecoration: 'none' }}>
                    <Text c="blue" style={{ cursor: 'pointer' }}>
                        {record.id}
                    </Text>
                </Link>
            )
        },
        { accessor: 'created', title: 'Created' },
    ];

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

        </SimpleGrid>
    );
};